<template>
  <div id="user-change-password">
    <a @click.stop="dialogChangePassword = true" class="green--text text--darken-3">
      เปลี่ยนรหัสผ่าน
    </a>
    <!-- Dialog Change Password -->
    <v-dialog
      v-model="dialogChangePassword"
      fullscreen
      transition="dialog-bottom-transition"
      :overlay="false"
      scrollable
      >
      <v-card tile>
        <!-- Header -->
        <v-toolbar card dark class="toolbar-change-password">
          <v-btn icon @click.native="dialogChangePassword = false" dark>
            <v-icon medium>close</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click="updateUserPassword" :disabled="dialogChangePasswordLoading" :loading="dialogChangePasswordLoading">บันทึก</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <!-- Conntent -->
        <v-card-text>
          <v-container grid-list-xl>
            <v-layout row wrap>
              <v-flex xs12 class="mb-4">
                <div class="headline">เปลี่ยนรหัสผ่านของคุณ</div>
                <div class="body-1">เพื่อความปลอดภัยของคุณเราขอแนะนำให้คุณเลือกรหัสผ่านเฉพาะที่คุณไม่ได้ใช้สำหรับบัญชีออนไลน์อื่น ๆ</div>
              </v-flex>
              <v-flex xs12 sm6 style="border-right: 1px solid #ebebeb;">
                <v-layout row wrap>
                  <!-- Password Zone -->
                  <v-flex xs12 class="pr-5">
                    <!-- New Password -->
                    <div class="subheading">รหัสผ่านใหม่</div>
                      <v-text-field
                        v-model="newpassword"
                        label="รหัสผ่าน"
                        :error-messages="errors.collect('newpassword')"
                        v-validate="'required|min:4'"
                        ref="newpassword"
                        required
                        :append-icon="passwordView ? 'visibility' : 'visibility_off'"
                        :append-icon-cb="() => (passwordView = !passwordView)"
                        :type="passwordView ? 'password' : 'text'"
                        >
                      </v-text-field>
                      <!-- Retype New Password -->
                      <div class="subheading">ยืนยันรหัสผ่านใหม่</div>
                      <v-text-field
                        v-model="confirmnewpassword"
                        label="รหัสผ่านอีกครั้ง"
                        :error-messages="errors.collect('confirmnewpassword')"
                        v-validate="'required|min:4|confirmed:$newpassword'"
                        data-vv-name="confirmnewpassword"
                        required
                        :append-icon="passwordView ? 'visibility' : 'visibility_off'"
                        :append-icon-cb="() => (passwordView = !passwordView)"
                        :type="passwordView ? 'password' : 'text'"
                        >
                      </v-text-field>
                  </v-flex>
                </v-layout>                
              </v-flex>  
              <v-flex xs12 sm6 class="pl-5">
                <!-- Condition -->
                <v-layout row wrap>
                  <v-flex xs12>
                    <div class="subheading">เงื่อนไข</div>
                  </v-flex>
                  <!-- <v-flex xs12>
                    <div class="catpion">Your password must not be the same as your last 5 passwords used</div>
                  </v-flex> -->
                  <v-flex xs12>
                    <div class="catpion">โปรดใส่รหัสผ่านที่มีจำนวน 6 ตัวอักษรขึ้นไป</div>
                  </v-flex>
                  <!-- <v-flex xs12>
                    <div class="catpion">Your password must have at least 1 number</div>
                  </v-flex>
                  <v-flex xs12>
                    <div class="catpion">Your password must contain no space(s)</div>
                  </v-flex> -->
                </v-layout>                
              </v-flex>               
              <v-flex xs12 sm6>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <div style="flex: 1 1 auto;"/>
      </v-card>
    </v-dialog>
    
  </div>
</template>

<script>
import axios from 'axios'
import iziToast from 'iziToast'

export default {
  name: 'user-change-password',
  data() {
    return {
      dialogChangePassword: false,
      dialogChangePasswordLoading: false,
      newpassword: '',
      confirmnewpassword: '',
      passwordView: true
    }
  },
  methods: {
    updateUserPassword: function() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.dialogChangePasswordLoading = !this.dialogChangePasswordLoading
          var that = this
          const data = {
            userid: this.$session.get('userid'),
            password: this.confirmnewpassword
          }
          axios
            .put('https://api.farmerspace.co/marketplace/updateUserPassword', data)
            .then(function(response) {
              if (response.data.message === true) {
                that.dialogChangePasswordLoading = !that.dialogChangePasswordLoading
                that.dialogChangePassword = !that.dialogChangePassword
                iziToast.info({
                  title: 'Password Updated!',
                  position: 'bottomRight'
                })
              } else {
                that.dialogChangePasswordLoading = !that.dialogChangePasswordLoading // Disable loading
                console.log(response.data)
                iziToast.error({
                  title: 'Failed',
                  position: 'bottomRight'
                })
              }
            })
            .catch(function(error) {
              console.log(error)
            })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/users/UserChangePassword.vue